export var ON_CONNECTION_STATE_CHANGED = "@@firekit/CONNECTION@ON_CONNECTION_STATE_CHANGED";